import $ from 'jquery'

const Bus = $({})

$(document).ready(() => Bus.trigger('setup'))
$(document).on('turbolinks:load', () => Bus.trigger('page:load'))
$(document).on('turbolinks:visit', () => Bus.trigger('page:exit'))

export default Bus
